"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getResourcePath = (params) => {
    return 'accountId' in params
        ? `/accounts/${params.accountId}`
        : `/projects/${params.projectId}`;
};
exports.default = getResourcePath;
